import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';

import { Page } from '@app/page/models/page';

@Component({
  selector: 'app-auth-layout-text',
  templateUrl: './auth-layout-text.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthLayoutTextComponent implements OnInit {
  @Input() page: Page | null;

  constructor() {}

  ngOnInit() {}
}
